import { useState } from 'react';

import { SignupForm } from '../components/signup-form';
import { ThemeLayout } from '../components/theme/theme-layout';

const Signup = ({ initialStep = 0 }: { initialStep?: number }) => {
  const [activeStep, setActiveStep] = useState(initialStep);
  return (
    <ThemeLayout variant={activeStep >= 1 ? 'centered' : 'split'}>
      <SignupForm activeStep={activeStep} setActiveStep={setActiveStep} />
    </ThemeLayout>
  );
};

export default Signup;
